export enum StubEnum {
  WorkspaceRemoval = '1048',
  QueueAccessDenied = '1049',
  QueueDeleted = '410',
  TaskNotFound = '404',
  InvalidUrl = '1111',
}
